(function (root, factory) {
  'use strict';
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.KineticUpgrade = api;
}(typeof window !== 'undefined' ? window : globalThis, function () {
  'use strict';

  var googleSource = 'https://support.google.com/pixelphone/answer/7158570?hl=en';
  var samsungSource = 'https://www.samsung.com/uk/smartphones/galaxy-a/';
  // Units: millimetres, grams, diagonal inches and maximum documented Hz.
  // null is intentional: Apple's linked base-model specifications omit Hz.
  var profiles = [
    { id: 'iphone-11', name: 'iPhone 11', system: 'apple', width: 75.7, height: 150.9, weight: 194, screen: 6.1, display: 'LCD', refresh: null, connector: 'Lightning', network: '4G', cameraNote: 'Principal con estabilizaci\u00f3n \u00f3ptica, ultra gran angular y v\u00eddeo 4K a 60 fps.', tradeoff: 'Pantalla LCD, sin 5G y sin teleobjetivo dedicado.', source: 'https://support.apple.com/en-ph/111865' },
    { id: 'iphone-12', name: 'iPhone 12', system: 'apple', width: 71.5, height: 146.7, weight: 164, screen: 6.1, display: 'OLED', refresh: null, connector: 'Lightning', network: '5G', cameraNote: 'Principal con estabilizaci\u00f3n \u00f3ptica, ultra gran angular y v\u00eddeo 4K a 60 fps.', tradeoff: 'Conector Lightning, no USB-C; sin teleobjetivo dedicado.', source: 'https://support.apple.com/en-us/111876' },
    { id: 'iphone-13', name: 'iPhone 13', system: 'apple', width: 71.5, height: 146.7, weight: 173, screen: 6.1, display: 'OLED', refresh: null, connector: 'Lightning', network: '5G', cameraNote: 'Estabilizaci\u00f3n por desplazamiento del sensor, ultra gran angular y v\u00eddeo 4K a 60 fps.', tradeoff: 'Conector Lightning, no USB-C; sin teleobjetivo dedicado.', source: 'https://support.apple.com/en-gb/111872' },
    { id: 'iphone-14', name: 'iPhone 14', system: 'apple', width: 71.5, height: 146.7, weight: 172, screen: 6.1, display: 'OLED', refresh: null, connector: 'Lightning', network: '5G', cameraNote: 'Estabilizaci\u00f3n por desplazamiento del sensor, ultra gran angular y modo Cine hasta 4K HDR a 30 fps.', tradeoff: 'Conector Lightning, no USB-C; sin teleobjetivo dedicado.', source: 'https://support.apple.com/en-us/111850' },
    { id: 'pixel-7a', name: 'Google Pixel 7a', system: 'android', width: 72.9, height: 152, weight: 193.5, screen: 6.1, display: 'OLED', refresh: 90, connector: 'USB-C', network: '5G', cameraNote: 'Principal con estabilizaci\u00f3n \u00f3ptica, ultra gran angular y v\u00eddeo 4K a 60 fps.', tradeoff: 'Refresco m\u00e1ximo de 90 Hz; sin teleobjetivo dedicado.', source: googleSource },
    { id: 'pixel-8a', name: 'Google Pixel 8a', system: 'android', width: 72.7, height: 152.1, weight: 189, screen: 6.1, display: 'OLED', refresh: 120, connector: 'USB-C', network: '5G', cameraNote: 'Principal con estabilizaci\u00f3n \u00f3ptica, ultra gran angular y v\u00eddeo 4K a 60 fps.', tradeoff: 'Sin teleobjetivo dedicado; c\u00e1mara frontal con enfoque fijo.', source: googleSource },
    { id: 'pixel-9a', name: 'Google Pixel 9a', system: 'android', width: 73.3, height: 154.7, weight: 185.9, screen: 6.3, display: 'pOLED', refresh: 120, connector: 'USB-C', network: '5G', cameraNote: 'Principal con estabilizaci\u00f3n \u00f3ptica, ultra gran angular, Macro Focus y v\u00eddeo 4K a 60 fps.', tradeoff: 'Sin teleobjetivo dedicado; anchura de 73,3 mm.', source: googleSource },
    { id: 'galaxy-a37', name: 'Samsung Galaxy A37 5G', system: 'android', width: 78.2, height: 162.9, weight: 196, screen: 6.7, display: 'Super AMOLED', refresh: 120, connector: 'USB-C', network: '5G', cameraNote: 'Principal con estabilizaci\u00f3n \u00f3ptica, ultra gran angular y macro; v\u00eddeo 4K a 30 fps.', tradeoff: 'Formato ancho de 78,2 mm; grabaci\u00f3n 4K limitada a 30 fps.', source: samsungSource + 'galaxy-a37-5g-awesome-charcoal-256gb-sm-a376bzageub/' },
    { id: 'galaxy-a57', name: 'Samsung Galaxy A57 5G', system: 'android', width: 76.8, height: 161.5, weight: 179, screen: 6.7, display: 'Super AMOLED Plus', refresh: 120, connector: 'USB-C', network: '5G', cameraNote: 'Principal con estabilizaci\u00f3n \u00f3ptica, ultra gran angular y macro; v\u00eddeo 4K a 30 fps.', tradeoff: 'Formato ancho de 76,8 mm; grabaci\u00f3n 4K limitada a 30 fps.', source: samsungSource + 'galaxy-a57-5g-awesome-navy-256gb-sm-a576bdbdeub/' }
  ].map(function (profile) { return Object.freeze(profile); });
  Object.freeze(profiles);

  // Discrete documented capabilities, not quality scores or battery-life estimates.
  // Supplemental Samsung spec sources and ranking policy: qa/kinetic-profile-sources.md.
  var facts = {
    'iphone-11': { ois: true, ultrawide: true, video60: true },
    'iphone-12': { ois: true, ultrawide: true, video60: true },
    'iphone-13': { ois: true, ultrawide: true, video60: true, sensorShift: true },
    'iphone-14': { ois: true, ultrawide: true, video60: true, sensorShift: true, cinematic4k: true },
    'pixel-7a': { ois: true, ultrawide: true, video60: true, battery: 4385 },
    'pixel-8a': { ois: true, ultrawide: true, video60: true, battery: 4492 },
    'pixel-9a': { ois: true, ultrawide: true, video60: true, macroFocus: true, battery: 5100 },
    'galaxy-a37': { ois: true, ultrawide: true, video60: false, battery: 5000 },
    'galaxy-a57': { ois: true, ultrawide: true, video60: false, battery: 5000 }
  };
  var profileById = new Map(profiles.map(function (p) { return [p.id, p]; }));
  var modifiers = '(?:pro|max|mini|plus|ultra|xl|fold|lite|fe|se)';
  var accessory = /\b(?:accesorios?|accessories|fundas?|cases?|covers?|carcasas?|protectores?|protector|cristal|templado|cargadores?|charger|cables?|adaptadores?|adapter|auriculares|headphones|earbuds|airpods|buds|repuestos?|recambios?|replacement|repair|reparacion|soportes?|holder|strap|correas?|smartwatch|watch|relojes?|tablets?|ipad|portatil|laptop|macbook|altavoz|speaker|powerbank|pack|kit|bundle)\b/;
  var numberFormat = new Intl.NumberFormat('es-ES', { maximumFractionDigits: 2 });

  function text(value) {
    if (typeof value !== 'string') return '';
    return value.slice(0, 2000)
      .replace(/<(script|style)\b[^>]*>[\s\S]*?<\/\1\s*>/gi, ' ')
      .replace(/<[^>]*>/g, ' ').replace(/[<>]/g, '')
      .replace(/[\u0000-\u001f\u007f-\u009f\u200b-\u200f\u202a-\u202e\u2060-\u206f]/g, ' ')
      .replace(/\s+/g, ' ').trim();
  }

  function tokens(value) {
    return text(value).normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase()
      .replace(/\b(iphone|pixel)(?=\d)/g, '$1 ')
      .replace(/\bpromax\b/g, 'pro max')
      .replace(/[^a-z0-9]+/g, ' ').trim().replace(/\s+/g, ' ');
  }

  function lexical(a, b) { return a < b ? -1 : a > b ? 1 : 0; }

  function identifier(value) {
    if (typeof value === 'number') return Number.isSafeInteger(value) && value > 0 ? value : null;
    return typeof value === 'string' && !/\s/.test(value) && /^[1-9]\d{0,19}$/.test(value) ? value : null;
  }

  function safeHandle(value) {
    return typeof value === 'string' && !/\s/.test(value) && /^[a-z0-9][a-z0-9-]{0,254}$/.test(value);
  }

  function accessoryTitle(value) {
    var title = tokens(value);
    return accessory.test(title) || /^(?:pantallas?|display|lcd|baterias?|battery|camara|camera)\b/.test(title);
  }

  function cents(value) {
    if (typeof value !== 'string' && typeof value !== 'number') return null;
    var input = String(value).trim();
    if (!/^\d+(?:\.\d{1,2})?$/.test(input)) return null;
    var parts = input.split('.');
    var result = Number(parts[0]) * 100 + Number(((parts[1] || '') + '00').slice(0, 2));
    return Number.isSafeInteger(result) && result > 0 ? result : null;
  }

  function safeImage(value) {
    if (typeof value !== 'string' || /[\s<>"'`\\]/.test(value)) return '';
    try {
      var url = new URL(value.indexOf('//') === 0 ? 'https:' + value : value);
      return url.protocol === 'https:' && !url.username && !url.password ? url.href : '';
    } catch (_) { return ''; }
  }

  function modelIdentity(title) {
    var input = tokens(title);
    var patterns = [
      /\biphone \d{1,2}[a-z]?(?: (?:pro|max|mini|plus|ultra|se)){0,2}\b/g,
      /\bpixel \d{1,2}[a-z]?(?: (?:pro|max|xl|fold)){0,2}\b/g,
      /\b(?:samsung )?galaxy (?:[asmfz]\d{1,3}[a-z]?|z (?:flip|fold) \d{1,2})(?: (?:ultra|plus|fe|lite|5g|4g)){0,2}\b/g,
      /\bsamsung [asmf]\d{1,3}[a-z]?(?: (?:ultra|plus|fe|lite|5g|4g)){0,2}\b/g,
      /\b(?:xiaomi )?(?:redmi|poco) (?:note )?[a-z]*\d{1,3}[a-z]?(?: (?:pro|max|plus|ultra|5g|4g)){0,3}\b/g,
      /\b(?:xiaomi|oneplus|realme|honor|motorola|moto|nothing phone) (?:edge |nord |magic )?[a-z]*\d{1,3}[a-z]?(?: (?:pro|max|plus|ultra|lite|5g|4g)){0,3}\b/g
    ];
    var hits = [];
    patterns.forEach(function (pattern) {
      var match;
      while ((match = pattern.exec(input))) {
        hits.push({ key: match[0].replace(/^samsung /, '').replace(/^xiaomi (?=redmi|poco)/, ''), length: match[0].length, index: match.index });
      }
    });
    // Longest token match wins only when the title identifies a single model.
    hits.sort(function (a, b) { return b.length - a.length || a.index - b.index; });
    var keys = new Set(hits.map(function (hit) { return hit.key; }));
    return keys.size === 1 ? hits[0].key : null;
  }

  function getProfile(title) {
    var input = tokens(title);
    if (accessoryTitle(title)) return undefined;
    var identity = modelIdentity(title);
    if (!identity) return undefined;
    if (/^iphone /.test(identity) && new RegExp('\\b' + modifiers + '\\b').test(input)) return undefined;
    var key = identity.replace(/^galaxy /, '').replace(/ (?:5g|4g)$/, '').replace(/ /g, '-');
    if (/^a(?:37|57)$/.test(key)) key = 'galaxy-' + key;
    // The verified A37/A57 profiles are 5G models, not a hypothetical 4G edition.
    if (/^galaxy-a/.test(key) && /\b4g\b/.test(identity)) return undefined;
    return profileById.get(key);
  }

  function phoneProduct(product, title) {
    var type = tokens(product.product_type);
    if (basicPhone(title)) return false;
    if (accessory.test(type) || /\b(?:pantallas?|baterias?|batteries)\b/.test(type) || accessoryTitle(title)) return false;
    return !!modelIdentity(title) || /\b(?:smartphones?|telefonos?|moviles?|mobile phones?|cell phones?)\b/.test(type);
  }

  function basicPhone(title) {
    return /\b(?:qubo|uleway|konka u6|shemers|nokia (?:150|2720|3310)|con tapa|feature phone|telefono basico|telefono de teclas)\b/.test(tokens(title));
  }

  function conditionOf(product, title) {
    var tags = Array.isArray(product.tags) ? product.tags.filter(function (t) { return typeof t === 'string'; }).join(' ') : product.tags;
    var description = tokens(title + ' ' + text(tags) + ' ' + text(product.product_type));
    if (/\b(?:reacondicionados?|refurbished|reconditioned|renewed)\b/.test(description)) return 'refurbished';
    if (/\b(?:usados?|used|segunda mano|open box)\b/.test(description)) return null;
    return 'new';
  }

  function priceOrder(a, b) {
    return a.price - b.price || lexical(a.handle || '', b.handle || '') || lexical(String(a.id), String(b.id));
  }

  function normalizeProducts(input) {
    if (!Array.isArray(input)) return [];
    var output = [];
    input.forEach(function (product) {
      if (!product || typeof product !== 'object' || Array.isArray(product)) return;
      var id = identifier(product.id);
      var title = text(product.title);
      var handle = safeHandle(product.handle) ? product.handle : '';
      if (!id || !title || !handle || !phoneProduct(product, title)) return;
      if (product.status && product.status !== 'active') return;
      var condition = conditionOf(product, title);
      if (!condition) return;
      var images = [product.image].concat(Array.isArray(product.images) ? product.images : []);
      var image = images.map(function (item) { return safeImage(typeof item === 'string' ? item : item && item.src); }).find(Boolean);
      if (!image) return;
      var variants = (Array.isArray(product.variants) ? product.variants : []).map(function (v) {
        if (!v || typeof v !== 'object') return null;
        var variantId = identifier(v.id);
        var price = cents(v.price);
        if (!variantId || price === null) return null;
        var compareAt = cents(v.compare_at_price);
        return { id: variantId, title: text(v.title) || 'Variante', price: price, available: v.available === true && !/\b(?:consultar|otro color|por confirmar)\b/.test(tokens(v.title)), compareAt: compareAt > price ? compareAt : 0 };
      }).filter(Boolean).sort(priceOrder);
      var seen = new Set();
      variants = variants.filter(function (v) { var key = String(v.id); if (seen.has(key)) return false; seen.add(key); return true; });
      var selected = variants.find(function (v) { return v.available; });
      if (!selected) return;
      var profile = getProfile(title);
      output.push({ id: id, handle: handle, title: title, shortTitle: profile ? profile.name : title.split(/\s[|\u00b7]\s|,/)[0], vendor: text(product.vendor), image: image, profile: profile, condition: condition, variants: variants, price: selected.price, variantId: selected.id });
    });
    return output.sort(priceOrder);
  }

  function systemOf(product) {
    if (product.profile) return product.profile.system;
    var identity = modelIdentity(product.title) || '';
    if (/^iphone /.test(identity)) return 'apple';
    if (/^(?:pixel|galaxy|redmi|poco|xiaomi|oneplus|realme|honor|motorola|moto|nothing phone) /.test(identity)) return 'android';
    return null;
  }

  function familyOf(product) {
    if (product.profile) return product.profile.id;
    var identity = modelIdentity(product.title);
    if (identity) return identity;
    // Without an identifiable family, keep only one price-only unknown per vendor.
    // This deliberately under-fills rather than showing colour/storage copies.
    return 'unknown:' + (tokens(product.vendor) || 'unidentified');
  }

  function canonicalProfile(value) {
    return profileById.get(typeof value === 'string' ? value : value && value.id);
  }

  function productFacts(product) {
    if (product.profile) return facts[product.profile.id] || {};
    var title = tokens(product.title);
    // Exact model boundaries: do not transfer specifications to adjacent models.
    if (/\bredmi 15\b/.test(title) && !/\b(?:note|pro|plus|ultra|5g)\b/.test(title)) return { battery: 7000, source: 'https://www.mi.com/global/product/redmi-15/specs/' };
    if (/\bmoto g15 power\b/.test(title)) return { battery: 6000, source: 'https://www.motorola.com/ro/ro/p/phones/moto-g/15-power/pmipmhj40m4' };
    return {};
  }

  function money(value) {
    if (!Number.isSafeInteger(value)) return 'Precio no disponible';
    return new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR', minimumFractionDigits: value % 100 ? 2 : 0, maximumFractionDigits: 2 }).format(value / 100);
  }

  function n(value) { return numberFormat.format(value); }

  function cameraGain(before, after) {
    if (!before || !after) return '';
    var a = facts[before.id], b = facts[after.id];
    if (!a || !b) return '';
    if (!a.video60 && b.video60) return 'Grabaci\u00f3n 4K a 60 fps frente a 30 fps.';
    if (!a.sensorShift && b.sensorShift) return 'A\u00f1ade estabilizaci\u00f3n por desplazamiento del sensor.';
    if (!a.cinematic4k && b.cinematic4k) return 'A\u00f1ade modo Cine hasta 4K HDR a 30 fps.';
    if (/^pixel-/.test(before.id) && !a.macroFocus && b.macroFocus) return 'A\u00f1ade Macro Focus a la c\u00e1mara principal.';
    return '';
  }

  function upgradeGain(best, next, priority) {
    var a = best.profile, b = next.profile;
    if (!a || !b) return '';
    if (priority === 'camera') return cameraGain(a, b);
    if (priority === 'battery') {
      var oldCapacity = facts[a.id].battery, newCapacity = facts[b.id].battery;
      return oldCapacity && newCapacity > oldCapacity ? 'Capacidad nominal de ' + n(newCapacity) + ' mAh frente a ' + n(oldCapacity) + ' mAh; no equivale a m\u00e1s horas de uso.' : '';
    }
    if (priority === 'compact') return b.width < a.width && b.height <= a.height ? 'Es ' + n(a.width - b.width) + ' mm m\u00e1s estrecho, sin aumentar la altura.' : '';
    if (a.network === '4G' && b.network === '5G') return 'A\u00f1ade conectividad 5G; requiere cobertura y tarifa compatibles.';
    if (a.display === 'LCD' && /OLED/.test(b.display)) return 'Cambia la pantalla LCD por ' + b.display + '.';
    if (a.refresh && b.refresh > a.refresh) return 'Refresco m\u00e1ximo de ' + b.refresh + ' Hz frente a ' + a.refresh + ' Hz; depende del contenido.';
    if (b.width < a.width && b.height <= a.height) return 'Formato m\u00e1s estrecho: ' + n(b.width) + ' mm frente a ' + n(a.width) + ' mm.';
    return cameraGain(a, b);
  }

  function selectBest(products, priority, current) {
    var qualified;
    if (priority === 'camera') {
      qualified = products.filter(function (p) { var f = productFacts(p); return f.ois && f.ultrawide; });
      if (current && facts[current.id] && facts[current.id].video60) {
        var preservesVideo = qualified.filter(function (p) { return productFacts(p).video60; });
        if (preservesVideo.length) return preservesVideo[0];
      }
      if (qualified.length) return qualified[0];
    }
    if (priority === 'battery') {
      qualified = products.filter(function (p) { return productFacts(p).battery; });
      qualified.sort(function (a, b) { return productFacts(b).battery - productFacts(a).battery || priceOrder(a, b); });
      if (qualified.length) return qualified[0];
    }
    if (priority === 'compact') {
      var widthLimit = current ? Math.min(73, current.width) : 73;
      qualified = products.filter(function (p) { return p.profile && p.profile.width <= widthLimit; });
      if (qualified.length) return qualified[0];
      qualified = products.filter(function (p) { return p.profile; });
      qualified.sort(function (a, b) { return a.profile.width - b.profile.width || a.profile.height - b.profile.height || priceOrder(a, b); });
      if (qualified.length) return qualified[0];
    }
    return products[0];
  }

  function priorityReason(product, priority) {
    var p = product.profile, f = productFacts(product);
    if (priority === 'battery' && f.battery) return (p ? p.name : product.shortTitle) + ': capacidad nominal de ' + n(f.battery) + ' mAh contrastada con el fabricante. No predice la autonom\u00eda real.';
    if (!p) return 'Propuesta basada solo en el precio; no se han comparado especificaciones verificadas de este modelo.';
    if (priority === 'camera') return p.name + ': ' + p.cameraNote + ' Se comparan funciones, no calidad fotogr\u00e1fica medida.';
    if (priority === 'battery') return f.battery ? p.name + ': capacidad nominal de ' + n(f.battery) + ' mAh. No predice la autonom\u00eda real.' : 'Sin capacidad de bater\u00eda comparable verificada para este modelo; la selecci\u00f3n se basa solo en el precio.';
    if (priority === 'compact') return p.name + ': ' + n(p.width) + ' mm de ancho, ' + n(p.height) + ' mm de alto y ' + n(p.weight) + ' g.';
    return p.name + ': pantalla ' + p.display + ' de ' + n(p.screen) + ' pulgadas y conexi\u00f3n ' + p.network + '.';
  }

  function recommendation(product, role, best, prefs, current, gain) {
    var reasons = [];
    if (role === 'save') reasons.push('Ahorras ' + money(best.price - product.price) + ' respecto a la propuesta principal.');
    else if (role === 'stepup') reasons.push('Por ' + money(product.price - best.price) + ' m\u00e1s que la propuesta principal: ' + gain);
    else if (prefs.priority === 'value') reasons.push('Es el precio m\u00e1s bajo entre los modelos que cumplen tus filtros.');
    else if (prefs.priority === 'camera' && product.profile) reasons.push(current && facts[current.id].video60 && productFacts(product).video60 ? 'La opci\u00f3n m\u00e1s econ\u00f3mica con estabilizaci\u00f3n, ultra gran angular y v\u00eddeo 4K a 60 fps, como tu m\u00f3vil actual.' : 'La opci\u00f3n m\u00e1s econ\u00f3mica con estabilizaci\u00f3n \u00f3ptica y ultra gran angular verificados.');
    else if (prefs.priority === 'battery' && productFacts(product).battery) reasons.push('La mayor capacidad nominal verificada dentro de tus filtros; no es una clasificaci\u00f3n de autonom\u00eda.');
    else if (prefs.priority === 'compact' && product.profile) reasons.push('Se prioriza una anchura de hasta ' + n(current ? Math.min(73, current.width) : 73) + ' mm al menor precio; si no hay, la menor anchura verificada.');
    else reasons.push('La opci\u00f3n m\u00e1s econ\u00f3mica dentro de tus filtros.');
    reasons.push('Precio de la variante: ' + money(product.price) + '. Margen de tu presupuesto para el m\u00f3vil: ' + money(prefs.budget - product.price) + '.');
    reasons.push(priorityReason(product, prefs.priority));
    if (current && product.profile) {
      if (current.id === product.profile.id) reasons.push('Es el mismo modelo que tu m\u00f3vil actual; no implica una mejora de especificaciones.');
      else if (current.connector !== product.profile.connector) reasons.push('El conector cambia de ' + current.connector + ' a ' + product.profile.connector + '; revisa tus cables.');
      else if (current.system !== product.profile.system) reasons.push('Cambias de ' + (current.system === 'apple' ? 'iOS' : 'Android') + ' a ' + (product.profile.system === 'apple' ? 'iOS' : 'Android') + '; comprueba tus apps y accesorios.');
    }
    var limitation = product.profile ? product.profile.tradeoff : (prefs.priority === 'battery' && productFacts(product).battery ? 'Se ha contrastado la capacidad de bater\u00eda; no se han clasificado la c\u00e1mara, la potencia ni las horas reales de uso.' : 'No se han comparado especificaciones verificadas de este modelo; la propuesta se basa solo en el precio.');
    if (prefs.priority === 'battery') limitation += ' La capacidad nominal no garantiza horas de uso.';
    if (product.condition === 'refurbished') limitation += ' Confirma la salud de bater\u00eda y el estado de la unidad reacondicionada.';
    return { product: product, role: role, reasons: reasons, limitation: limitation, source: productFacts(product).source || null };
  }

  function recommend(products, prefs) {
    if (!Array.isArray(products) || !prefs || !Number.isSafeInteger(prefs.budget) || prefs.budget <= 0) return [];
    if (['any', 'apple', 'android'].indexOf(prefs.system) === -1 || ['any', 'new', 'refurbished'].indexOf(prefs.condition) === -1 || ['camera', 'battery', 'value', 'compact'].indexOf(prefs.priority) === -1) return [];
    var current = canonicalProfile(prefs.current);
    var eligible = [];
    products.forEach(function (p) {
      if (!p || !identifier(p.id) || !Array.isArray(p.variants) || !safeImage(p.image) || !safeHandle(p.handle)) return;
      if (['new', 'refurbished'].indexOf(p.condition) === -1 || (prefs.condition !== 'any' && prefs.condition !== p.condition)) return;
      // Re-resolve the title instead of trusting a caller-supplied profile or minimum price.
      var product = { id: p.id, handle: p.handle, title: text(p.title), shortTitle: text(p.shortTitle), vendor: text(p.vendor), image: safeImage(p.image), profile: getProfile(p.title), condition: p.condition };
      if (!product.title || accessoryTitle(product.title) || basicPhone(product.title)) return;
      if (prefs.system !== 'any' && systemOf(product) !== prefs.system) return;
      product.variants = p.variants.filter(function (v) { return v && identifier(v.id) && v.available === true && Number.isSafeInteger(v.price) && v.price > 0 && v.price <= prefs.budget; }).map(function (v) {
        return { id: v.id, title: text(v.title) || 'Variante', price: v.price, available: true, compareAt: Number.isSafeInteger(v.compareAt) && v.compareAt > v.price ? v.compareAt : 0 };
      }).sort(priceOrder);
      if (!product.variants.length) return;
      product.price = product.variants[0].price;
      product.variantId = product.variants[0].id;
      eligible.push(product);
    });
    eligible.sort(priceOrder);
    var families = new Set();
    eligible = eligible.filter(function (p) { var family = familyOf(p); if (families.has(family)) return false; families.add(family); return true; });
    if (!eligible.length) return [];
    if (current) {
      var alternatives = eligible.filter(function (p) { return !p.profile || p.profile.id !== current.id; });
      if (alternatives.length) eligible = alternatives;
    }
    var best = selectBest(eligible, prefs.priority, current);
    var results = [recommendation(best, 'best', best, prefs, current)];
    var save = eligible.find(function (p) { return p.price < best.price && (prefs.priority === 'value' || !!p.profile); });
    if (save) results.push(recommendation(save, 'save', best, prefs, current));
    var stepup = eligible.find(function (p) { return p.price > best.price && upgradeGain(best, p, prefs.priority); });
    if (stepup) results.push(recommendation(stepup, 'stepup', best, prefs, current, upgradeGain(best, stepup, prefs.priority)));
    return results;
  }

  function compare(currentProfile, nextProfile) {
    var a = canonicalProfile(currentProfile), b = canonicalProfile(nextProfile);
    if (!a || !b) return [];
    var rows = [];
    function add(label, key, unit, note) {
      if (a[key] == null && b[key] == null) return;
      var format = function (value) { return value == null ? 'Sin dato verificado' : (typeof value === 'number' ? n(value) : value) + (unit || ''); };
      var row = { label: label, before: format(a[key]), after: format(b[key]) };
      if (note) row.note = note;
      rows.push(row);
    }
    add('Anchura', 'width', ' mm', 'Dimensiones del modelo, no una representaci\u00f3n a tama\u00f1o real.');
    add('Altura', 'height', ' mm');
    add('Peso', 'weight', ' g', 'Puede variar por configuraci\u00f3n y fabricaci\u00f3n.');
    add('Pantalla', 'screen', ' pulgadas', 'Diagonal nominal; la superficie visible es menor por las esquinas.');
    add('Tecnolog\u00eda de pantalla', 'display');
    add('Refresco m\u00e1ximo', 'refresh', ' Hz', 'El m\u00e1ximo depende del contenido y los ajustes.');
    add('Conector', 'connector');
    add('Red m\u00f3vil', 'network', '', 'La disponibilidad depende de la variante regional, la tarifa y la cobertura.');
    add('C\u00e1mara', 'cameraNote', '', 'Funciones oficiales del modelo, no una medici\u00f3n de calidad fotogr\u00e1fica.');
    var oldBattery = facts[a.id].battery, newBattery = facts[b.id].battery;
    if (oldBattery || newBattery) rows.push({ label: 'Capacidad nominal de bater\u00eda', before: oldBattery ? n(oldBattery) + ' mAh' : 'Sin dato comparable verificado', after: newBattery ? n(newBattery) + ' mAh' : 'Sin dato comparable verificado', note: 'No equivale a autonom\u00eda ni a salud de bater\u00eda de una unidad; el uso y el desgaste influyen.' });
    return rows;
  }

  return Object.freeze({ profiles: profiles, normalizeProducts: normalizeProducts, recommend: recommend, compare: compare, getProfile: getProfile, money: money });
}));
